import React from "react";
import CrudTable from "../components/CrudTable";

const columns = [
  { key: "recovery_id", label: "Recovery ID" },
  { key: "asset_id", label: "Asset", render: (v) => v ? v.slice(0, 8) + "…" : "-" },
  { key: "reason", label: "Reason" },
  { key: "assigned_team", label: "Team" },
  { key: "status", label: "Status", status: true },
];
const formFields = [
  { name: "asset_id", label: "Asset ID", required: true },
  { name: "outlet_id", label: "Outlet ID" },
  { name: "reason", label: "Reason", required: true, wide: true },
  { name: "assigned_team", label: "Assigned Team" },
  { name: "recovery_date", label: "Recovery Date", type: "date" },
  { name: "inspection_notes", label: "Inspection Notes", wide: true },
  { name: "recovery_cost", label: "Recovery Cost (₹)", type: "number", default: 0 },
  { name: "status", label: "Status", type: "select", default: "open",
    options: ["open", "in_progress", "closed", "approved", "rejected"].map((s) => ({ value: s, label: s })) },
];

export default function Recovery() {
  return <CrudTable title="Recovery Cases"
    description="Retrieve, inspect and re-route assets from the field."
    endpoint="/recovery" columns={columns} formFields={formFields} />;
}
